/* Progressive enhancement: department links remain available without JavaScript. */
(function () {
  function normalize(value) {
    return String(value || '').normalize('NFKD').replace(/[\u0591-\u05BD\u05BF-\u05C7\u0300-\u036f]/g, '').toLowerCase()
      .replace(/\b(tallit|talleisim|tallitot)\b/g, 'tallis')
      .replace(/\b(kippot|kippah|kippa|kipah|yarmulke|yamulaka|yarmulkas)\b/g, 'yarmulka')
      .replace(/\b(tzitzit|tzitzith)\b/g, 'tzitzis')
      .replace(/\b(tefilin|teflin)\b/g, 'tefillin')
      .replace(/\b(sefarim|sefer)\b/g, 'seforim')
      .replace(/\b(chumashim)\b/g, 'chumash').replace(/\b(siddurim)\b/g, 'siddur')
      .replace(/\b(machzorim)\b/g, 'machzor').replace(/\b(shabbat)\b/g, 'shabbos')
      .replace(/\b(sukkos|succos|succot)\b/g, 'sukkot')
      .replace(/\b(books|toys|gifts|players|lamps|shtenders|kittels|bags)\b/g, function (word) { return word.slice(0, -1); })
      .replace(/[^a-z0-9\u05d0-\u05ea]+/g, ' ').trim();
  }
  function start(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var controls = root.querySelector('.jsq-directory__controls');
    var input = root.querySelector('[data-directory-query]');
    var status = root.querySelector('[data-directory-status]');
    var empty = root.querySelector('[data-directory-empty]');
    var search = root.querySelector('[data-directory-search]');
    var groups = Array.from(root.querySelectorAll('.jqp-directory__group')).map(function (group) {
      return { element: group, heading: normalize(group.querySelector('h2').textContent), links: Array.from(group.querySelectorAll('li')).map(function (li) { return { element: li, text: normalize(li.textContent + ' ' + li.querySelector('a').getAttribute('href')) }; }) };
    });
    function update() {
      var terms = normalize(input.value).split(/\s+/).filter(Boolean);
      var total = 0;
      groups.forEach(function (group) {
        var count = 0;
        group.links.forEach(function (item) {
          var text = group.heading + ' ' + item.text;
          var match = terms.every(function (term) { return text.indexOf(term) !== -1; });
          item.element.hidden = !match;
          if (match) count++;
        });
        group.element.hidden = count === 0;
        total += count;
      });
      status.textContent = status.dataset.countTemplate.replace('[count]', total);
      empty.hidden = total !== 0;
      search.hidden = terms.length === 0;
      var url = new URL(search.getAttribute('href'), location.origin);
      url.searchParams.set('q', input.value.trim());
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      search.href = url.pathname + url.search;
    }
    controls.hidden = false;
    input.addEventListener('input', update);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { input.value = ''; update(); }
      if (event.key === 'Enter' && input.value.trim()) { event.preventDefault(); location.assign(search.href); }
    });
    root.querySelector('[data-directory-clear]').addEventListener('click', function () { input.value = ''; update(); input.focus(); });
    update();
  }
  function init(scope) { scope.querySelectorAll('[data-jsq-directory]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
